import CompanyClientView from './CompanyClientView.container';

export default CompanyClientView;
